export default function GetStartedHero() {
  return (
    <section className="pt-32 pb-16 px-6 lg:px-12">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
          Get Started
        </h1>
        <p className="text-lg text-gray-700 mb-4 leading-relaxed">
          Tell us a little about your business and we'll map how
          <br />
          Automigo would work for you.
        </p>
        <p className="text-base text-gray-600">
          No commitment and no preparation needed.
        </p>
      </div>
    </section>
  );
}
